import resolveComponent from '../resolveComponent';

/**
 * @example `/${appid}${appHomePrefix}`
 * @example `/:appId${appHomePrefix}`
 *  */
const appHomePrefix = '/home';

export { appHomePrefix };

const HomeRouteConfig = [
  {
    path: `/:appId${appHomePrefix}`,
    label: '首页',
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId${appHomePrefix}`,
        exact: true,
        label: '公众号首页',
        component: resolveComponent(() => import('@src/pages/app/home')),
      },
    ],
  },
  {
    path: `${appHomePrefix}`,
    label: '首页',
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `${appHomePrefix}`,
        exact: true,
        label: '公众号首页',
        component: resolveComponent(() => import('@src/pages/app/home')),
      },
    ],
  },
];

export default HomeRouteConfig;
